import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import API from '../api/axios';

const FOOTER_FALLBACK = {
 quote:
 '“St. Andrews World School, the Best CBSE School in Gurugram, has been accredited with the ‘Excellence in Education in Schooling’ Award, which marks the excellence of our modern curriculum.”',
 navigation: [
 { title: 'About St. Andrews Group', url: '/about-standrews-group' },
 { title: 'Other Facilities', url: '/other-facilities' },
 { title: 'Admission', url: '/admission' },
 { title: 'Gallery', url: '/gallery' },
 { title: 'Contact Us', url: '/contact' },
 ],
 social: [
 { title: 'Facebook', key: 'facebook', icon: 'fab fa-facebook-f' },
 { title: 'Twitter', key: 'twitter', icon: 'fab fa-twitter' },
 { title: 'YouTube', key: 'youtube', icon: 'fab fa-youtube' },
 { title: 'Instagram', key: 'instagram', icon: 'fab fa-instagram' },
 { title: 'LinkedIn', key: 'linkedin', icon: 'fab fa-linkedin-in' },
 ],
 contact: {
 address: 'Opposite Orris Aster Court, Sector-85, Gurugram, Haryana-122004',
 phone: '9643813920,9643813921',
 email: 'admissions@sawsgurugram.com',
 },
 copyright: 'St. Andrews World School. All right reserved.',
};

const Footer = () => {
 const [settings, setSettings] = useState({});
 const [contacts, setContacts] = useState({});

 useEffect(() => {
 const fetchData = async () => {
 try {
 const [settingRes, contactRes] = await Promise.all([
 API.get('/settings/public'),
 API.get('/contacts/public')
 ]);
 setSettings(settingRes.data.data || {});
 setContacts(contactRes.data.data || {});
 } catch (err) { console.error(err); }
 };
 fetchData();
 }, []);

 const effectiveNav = FOOTER_FALLBACK.navigation;

 const effectiveSocial = FOOTER_FALLBACK.social;

 const effectiveAddress = contacts.address || FOOTER_FALLBACK.contact.address;
 const effectivePhone = contacts.phone || FOOTER_FALLBACK.contact.phone;
 const effectiveEmail = contacts.email || FOOTER_FALLBACK.contact.email;

 const socialHref = (key) => contacts[key] || '#';

 return (
 <footer className="bg-[#1b3160] text-white pt-14 pb-0 relative overflow-hidden">
 <div className="absolute inset-0 pointer-events-none">
 <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full bg-secondary/5 blur-3xl"></div>
 <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(#1b3160_1px,transparent_1px)] [background-size:32px_32px]"></div>
 </div>
 <div className="container relative">
 <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10 md:gap-12">
 {/* Column 1: About School */}
 <div>
 <h3 className="text-white/80 tracking-[0.14em] uppercase text-[15px] font-semibold">About School</h3>
  <div className="w-10 h-[3px] mb-2 bg-gradient-to-r from-secondary to-secondary-light rounded-full"></div>
 <p className="text-white/90 leading-relaxed">
 {settings.footer_text || FOOTER_FALLBACK.quote}
 </p>
 </div>

 {/* Column 2: Navigation */}
 <div>
 <h3 className="text-white/80 tracking-[0.14em] uppercase text-[15px] font-semibold">Navigation</h3>
  <div className="w-10 h-[3px] mb-2 bg-gradient-to-r from-secondary to-secondary-light rounded-full"></div>
 <ul className="space-y-2.5">
 {effectiveNav.map((m) => (
 <li key={m.url}>
 <Link to={m.url} className="text-white/90 hover:text-white transition-colors">
 {m.title}
 </Link>
 </li>
 ))}
 </ul>
 </div>

 {/* Column 3: Social */}
 <div>
 <h3 className="text-white/80 tracking-[0.14em] uppercase text-[15px] font-semibold">Social Media</h3>
  <div className="w-10 h-[3px] mb-2 bg-gradient-to-r from-secondary to-secondary-light rounded-full"></div>
 <ul className="space-y-2.5">
 {effectiveSocial.map((s) => (
 <li key={s.key}>
 <a
 href={socialHref(s.key)}
 target="_blank"
 rel="noopener noreferrer"
 className="text-white/90 hover:text-white transition-colors inline-flex items-center gap-2"
 aria-label={s.title}
 >
 <i className={`${s.icon} text-[15px] w-5 text-center`} aria-hidden />
 <span>{s.title}</span>
 </a>
 </li>
 ))}
 </ul>
 </div>

 {/* Column 4: Contact */}
 <div>
   <h3 className="text-white/80 tracking-[0.14em] uppercase text-[15px] font-semibold">Contact Us</h3>
  <div className="w-10 mb-2 h-[3px] bg-gradient-to-r from-secondary to-secondary-light rounded-full"></div>

 <div className="space-y-3 text-white/90 leading-relaxed">
 <p>
 <span className="text-white/60 text-[15px] uppercase tracking-wider block mb-0.5">Address</span>
 {effectiveAddress}
 </p>
 <p>
 <span className="text-white/60 text-[15px] uppercase tracking-wider block mb-0.5">Phone</span>
 {effectivePhone ? (
 effectivePhone.split(/[,|]/).map((phone, i) => (
 <a key={i} href={`tel:+91${phone.trim()}`} className="text-white/90 hover:text-white transition-colors block">
 +91-{phone.trim()}
 </a>
 ))
 ) : (
 <>
 <a href="tel:+919643813920" className="text-white/90 hover:text-white transition-colors block">+91-9643813920</a>, <a href="tel:+919643813921" className="text-white/90 hover:text-white transition-colors block">+91-9643813921</a>
 </>
 )}
 </p>
 <p>
 <span className="text-white/60 text-[15px] uppercase tracking-wider block mb-0.5">Email</span>
 <a href={`mailto:${effectiveEmail || 'admissions@sawsgurugram.com'}`} className="text-white/90 hover:text-white transition-colors">
 {effectiveEmail || 'admissions@sawsgurugram.com'}
 </a>
 </p>
 </div>
 </div>
 </div>
 </div>

 <div className="mt-12 border-t border-white/5">
 <div className="container py-6">
 <div className="flex flex-col items-center gap-5">
 <img
 src="/images/cambridge-knowledge-partner.jpg"
 alt="Cambridge Assessment"
 className="h-14 w-auto md:hidden"
 loading="lazy"
 />
 <div className="text-white/55 text-center">
 {settings.footer_credit || FOOTER_FALLBACK.copyright}
 </div>
 </div>
 </div>
 </div>
 </footer>
 );
};

export default Footer;
